var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8349 10.1246C10.8349 9.64138 10.4618 9.24963 10.0016 9.24963C9.54132 9.24963 9.16822 9.64138 9.16822 10.1246V13.7001L8.5059 13.0047C8.18046 12.663 7.65283 12.663 7.32739 13.0047C7.00195 13.3464 7.00195 13.9004 7.32739 14.2421L8.82304 15.8125C9.47392 16.4959 10.5292 16.4959 11.1801 15.8125L12.6726 14.2454C12.998 13.9037 12.998 13.3497 12.6726 13.008C12.3471 12.6663 11.8195 12.6663 11.4941 13.008L10.8349 13.7001V10.1246Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6789 6.47491C1.73204 5.944 1.95689 5.44528 2.3197 5.06434L4.26779 3.01884C4.73663 2.52656 5.37251 2.25 6.03555 2.25H13.9645C14.6275 2.25 15.2634 2.52656 15.7323 3.01884L17.6803 5.06434C18.0432 5.44529 18.268 5.944 18.3211 6.47492C18.3292 6.52368 18.3334 6.57383 18.3334 6.625V17.125C18.3334 18.5747 17.2141 19.75 15.8334 19.75H4.16669C2.78597 19.75 1.66669 18.5747 1.66669 17.125V6.625C1.66669 6.57383 1.67087 6.52368 1.6789 6.47491ZM6.03555 4H13.9645C14.1855 4 14.3975 4.09219 14.5537 4.25628L15.9763 5.75H4.02371L5.4463 4.25628C5.60258 4.09219 5.81454 4 6.03555 4ZM3.33335 7.5V17.125C3.33335 17.6082 3.70645 18 4.16669 18H15.8334C16.2936 18 16.6667 17.6082 16.6667 17.125V7.5H3.33335Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.cd761ec16c26c33ad09eebe4340d2483.svg";
export { ForwardRef as ReactComponent };